import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { ArbeitspaketeListe } from '../components/ArbeitspaketeListe';
import { ApTaskGanttSection } from '../components/ApTaskGanttSection';
import { ProjectGanttSection } from '../components/ProjectGanttSection';

/**
 * Projektplan-Tab.
 * - Mit ?ap=<id> (Sidebar-Subpunkt): Detailansicht eines einzelnen Arbeitspakets
 *   (Kopf-Infos + dessen Aufgaben-Gantt), damit große Projekte nicht alle APs
 *   auf einer Seite zeigen müssen.
 * - Ohne ?ap: Landing-Übersicht — der Gesamt-Gantt oben (wichtigster Teil der
 *   Seite, PHQ-96), darunter die einklappbare AP-Liste. Den früheren
 *   Aufgaben-Bereich je AP gibt es hier nicht mehr (PHQ-95): Aufgaben gehören
 *   aufs Kanban-Board zum AP. Reifegrad-Schritt 11 wird hier gesynct.
 */
export function ProjektplanTab({ projectId, apId }: { projectId: string; apId?: string | null }) {
  const { t } = useTranslation('projects');

  if (apId) {
    return <ApTaskGanttSection projectId={projectId} focusApId={apId} />;
  }

  return (
    <Stack spacing={2}>
      <ProjectGanttSection projectId={projectId} maturityStep={11} />

      <Accordion disableGutters defaultExpanded slotProps={{ transition: { unmountOnExit: true } }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {t('arbeitspakete.title', 'Arbeitspakete')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ArbeitspaketeListe projectId={projectId} />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
